module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "ct"
  }, [_c('a', {
    attrs: {
      "href": "#/APerfectSecreteBook2"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("ab im kopp")]), _vm._v("—off in the head, crazy")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("ach—")]), _vm._v("oh")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("aenti")]), _vm._v("—aunt")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("appeditlich—")]), _vm._v("delicious")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("bensel—")]), _vm._v("hard to handle; a handful")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("bruder")]), _vm._v("—brother")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("daadi haus")]), _vm._v("—a small house built onto or near the main house for grandparents to live in")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("daag")]), _vm._v("—day")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("daed")]), _vm._v("—dad")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("danki")]), _vm._v("—thanks")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Derr Herr")]), _vm._v("—God")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("dochder")]), _vm._v("—daughter")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("dumm")]), _vm._v("—dumb")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("dummkopf")]), _vm._v("—dummy")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("eck")]), _vm._v("—special place for bride and groom at the corner of the wedding table")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Englisch")]), _vm._v("—non-Amish")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Englischer")]), _vm._v("—a non-Amish person")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("familye")]), _vm._v("—family")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("frau")]), _vm._v("—wife")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("freind")]), _vm._v("—friend")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("geh")]), _vm._v("—go")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("gut")]), _vm._v("—good")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("haus")]), _vm._v("—house")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("hiya—")]), _vm._v("hello")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("kaffee")]), _c('em', {
    staticClass: "i"
  }, [_vm._v("—")]), _vm._v("coffee")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("kapp")]), _vm._v("—prayer covering or cap")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("kinn, kinner")]), _vm._v("—child, children")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("kumme")]), _vm._v("—come")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("lieb")]), _vm._v("—love")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("maedel ")]), _vm._v("or"), _c('em', {
    staticClass: "i"
  }, [_vm._v(" maed")]), _vm._v("—girl or girls")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("mamm")]), _vm._v("—mom")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("mann")]), _vm._v("—man, men")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("mei")]), _vm._v("—my")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("milch—")]), _vm._v("milk")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("mudder")]), _vm._v("—mother")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("narrisch")]), _vm._v("—crazy")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("nee")]), _vm._v("—no")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("nix")]), _vm._v("—nothing")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("onkel")]), _vm._v("—uncle")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("roascht—")]), _vm._v("bread stuffing and chicken baked in a casserole")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("rumschpringe")]), _vm._v("—running-around period when a teenager turns sixteen years old")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("schee")]), _vm._v("—handsome")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("schwester")]), _vm._v("—sister")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("seltsam")]), _vm._v("—weird")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("sohn")]), _vm._v("—son")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("was in der welt—")]), _vm._v("what in the world")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("wunderbaar")]), _vm._v("—wonderful")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("ya")]), _vm._v("—yes")]), _vm._v(" "), _c('p', {
    staticClass: "glo"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Yankee—")]), _vm._v("non-Amish person, term used in Middlefield, Ohio")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5169c6d5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/APerfectSecreteBook5.vue
// module id = 72
// module chunks = 0